<template>
    <div :class="class_name">
        <div v-if="closeable" class="modal-shadow" @click="close"></div>
        <div v-else class="modal-shadow"></div>

        <div class="modal-inner">
            <div class="modal-header">
                <div v-if="closeable" class="modal-close" @click="close"><i class="material-icons">close</i></div>

                <slot name="header"></slot>
            </div>

            <div class="modal-body">
                <slot name="content"></slot>
            </div>

            <div class="modal-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "modal",

    props: {
        closeable: {
            default: true,
            required: false,
            type: Boolean
        },
        noFooter: {
            default: false,
            required: false,
            type: Boolean
        },
        size: {
            required: false,
            type: String
        },
        state: {
            required: false,
            type: String
        }
    },

    computed: {
        class_name: function () {
            let classes = [
                "modal"
            ]

            if (this.size) {
                classes.push(this.size)
            }

            if (this.state) {
                classes.push(this.state)
            }

            if (this.noFooter) {
                classes.push("no-footer")
            }

            return classes.join(" ")
        }
    },

    methods: {
        close: function () {
            this.$emit("close")
        }
    }
}
</script>

<style>
.modal {
    align-items: center;
    display: flex;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 4;
}

.modal-shadow {
    background: rgba(0, 0, 0, 0.25);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
}

.modal-close {
    color: inherit;
    cursor: pointer;
    font-size: 1.6em;
    padding: 2px 6px;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    user-select: none;
}

.modal-inner {
    background: #fff;
    border: 1px solid #bdbdbd;
    border-radius: 2px;
    box-shadow: 0px 0px 6px #909090;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-height: calc(100% - 40px);
    max-width: calc(100% - 20px);
    position: relative;
    /* top: 50%; */
    /* transform: translateY(-50%) translateZ(0); */
    width: 550px;
    z-index: 2;
}

.modal.medium .modal-inner {
    width: 750px;
}

.modal.large .modal-inner {
    width: 1000px;
}

.modal-header {
    background: #95ffce;
    border-bottom: 1px solid #7ed5ad;
    box-shadow: 0px 0px 4px #77c5a1;
    color: #686868;
    font-weight: 700;
    flex: 0;
    padding: 15px 20px;
    position: relative;
}

.modal.bad .modal-header {
    background: #ff6050;
    border-color: #d22f2f;
    box-shadow: 0px 0px 4px #c03d3d;
    color: #fff;
}

.modal-body {
    flex: 1;
    padding: 15px 20px;
    overflow-x: hidden;
    overflow-y: scroll;
    will-change: transform;
}

.modal-footer {
    padding: 15px 20px;
}

.modal.no-footer .modal-footer {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue